function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return(this, result);
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Component } from "react";
import { connect } from "react-redux";
import CustomScrollbar from "@common/components/CustomScrollbar";
import { closeModal } from "@common/actions/index";
import RichText from "@common/components/BoxDetailsTab/RichText";
import { FAQ_QUESTION_TYPES } from "@common/constants";
import { SCROLLBAR } from "@common/services/responsive";
import { KEY_ENTER } from "@config/constants";
import Spinner from "@common/components/Spinner";
import { hashCode } from "@common/utils/helpers";
import PrismicClient from "@common/utils/prismic";
import { SNACKBAR_AUTOHIDE_TIMEOUT, SNACKBAR_VARIANT_ERROR } from "@config/constants";
import { isEmpty } from "lodash";
import { withSnackbar } from "notistack";
var FrequentlyAskedQuestions = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(FrequentlyAskedQuestions, Component);
    var _super = _create_super(FrequentlyAskedQuestions);
    function FrequentlyAskedQuestions(props) {
        _class_call_check(this, FrequentlyAskedQuestions);
        var _this;
        _this = _super.call(this, props);
        _this.handleClick = _this.handleClick.bind(_assert_this_initialized(_this));
        _this.handleKeydown = _this.handleKeydown.bind(_assert_this_initialized(_this));
        _this.wrapperRef = null;
        _this.focusTimeout = null;
        _this.state = {
            faqData: null
        };
        return _this;
    }
    _create_class(FrequentlyAskedQuestions, [
        {
            /**
     *  Toggles the answer for a question
     *  @param {Object} event
     */ key: "handleClick",
            value: function handleClick(event) {
                //Here we are manipulating the DOM directly because the modal content is comming
                // as a constant from translations.
                if (event.target.classList.contains("question-answer-wrapper")) {
                    event.target.classList.contains("open") ? event.target.classList.remove("open") : event.target.classList.add("open");
                }
            }
        },
        {
            /**
     *  Toggles the answer for a question on enter keydown and sets tabindexes of links
     *  @param {Object} event
     */ key: "handleKeydown",
            value: function handleKeydown(event) {
                var key = event.which;
                if (key === KEY_ENTER) {
                    this.handleClick(event);
                    var links = event.target.getElementsByTagName("a");
                    if (event.target.classList.contains("open")) {
                        Array.prototype.forEach.call(links, function(link) {
                            link.setAttribute("tabIndex", "0");
                        });
                    } else {
                        Array.prototype.forEach.call(links, function(link) {
                            link.setAttribute("tabIndex", "-1");
                        });
                    }
                }
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this = this;
                return _async_to_generator(function() {
                    var faqData, e, _this_props_i18n_errors_prismic, localizedErrorMessage;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.focusTimeout = setTimeout(function() {
                                    _this.wrapperRef.focus();
                                }, 0);
                                if (!PrismicClient.hasPrismic()) return [
                                    2
                                ];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    PrismicClient.getFaq()
                                ];
                            case 2:
                                faqData = _state.sent();
                                _this.setState({
                                    faqData: faqData
                                });
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                e = _state.sent();
                                localizedErrorMessage = ((_this_props_i18n_errors_prismic = _this.props.i18n.errors.prismic) === null || _this_props_i18n_errors_prismic === void 0 ? void 0 : _this_props_i18n_errors_prismic[e.message]) || _this.props.i18n.errors.generic;
                                _this.props.enqueueSnackbar(localizedErrorMessage, {
                                    variant: SNACKBAR_VARIANT_ERROR,
                                    autoHideDuration: SNACKBAR_AUTOHIDE_TIMEOUT
                                });
                                _this.props.closeModal();
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                clearTimeout(this.focusTimeout);
            }
        },
        {
            key: "renderHardcoded",
            value: function renderHardcoded() {
                var i18n = this.props.i18n;
                return /*#__PURE__*/ _jsx("div", {
                    className: "message-wrapper",
                    dangerouslySetInnerHTML: {
                        __html: i18n.faqModalContent
                    }
                });
            }
        },
        {
            key: "renderQuestion",
            value: function renderQuestion(questionData, index) {
                var _questionData_question_, _questionData_question;
                var lastType = null;
                var listItemKey = null;
                var answerChildren = [];
                var listChildren = [];
                var addListItems = function() {
                    if (isEmpty(listChildren)) return;
                    var listParent = lastType === "o-list-item" ? /*#__PURE__*/ _jsx("ol", {
                        children: listChildren
                    }, listItemKey) : /*#__PURE__*/ _jsx("ul", {
                        children: listChildren
                    }, listItemKey);
                    answerChildren.push(listParent);
                };
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.entries(questionData.answer)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = _sliced_to_array(_step.value, 2), i = _step_value[0], answerData = _step_value[1];
                        var answerChildKey = "".concat(i, "_").concat(hashCode(answerData.text));
                        if (answerData.type !== lastType) {
                            addListItems();
                            listChildren = [];
                            listItemKey = null;
                        }
                        switch(answerData.type){
                            case "paragraph":
                                answerChildren.push(/*#__PURE__*/ _jsx(RichText, _object_spread({}, answerData), answerChildKey));
                                break;
                            case "o-list-item":
                            case "list-item":
                                if (!listItemKey) {
                                    listItemKey = answerChildKey;
                                }
                                listChildren.push(/*#__PURE__*/ _jsx("li", {
                                    children: /*#__PURE__*/ _jsx(RichText, _object_spread({}, answerData))
                                }, "li_".concat(answerChildKey)));
                                break;
                        }
                        lastType = answerData.type;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                addListItems();
                var className = "";
                if (questionData.type === FAQ_QUESTION_TYPES.EXPANDED) {
                    className = "question-topic-section";
                } else if (questionData.type === FAQ_QUESTION_TYPES.CLOSED) {
                    className = "question-answer-wrapper pointer";
                }
                return /*#__PURE__*/ _jsxs("div", {
                    className: className,
                    children: [
                        /*#__PURE__*/ _jsx("p", {
                            className: "question",
                            children: (_questionData_question = questionData.question) === null || _questionData_question === void 0 ? void 0 : (_questionData_question_ = _questionData_question[0]) === null || _questionData_question_ === void 0 ? void 0 : _questionData_question_.text
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "answer",
                            children: answerChildren
                        })
                    ]
                }, index);
            }
        },
        {
            key: "renderQuestionSection",
            value: function renderQuestionSection(sectionData) {
                var _this = this;
                var _sectionData_primary_section_title_, _sectionData_primary_section_title, _sectionData_primary, _sectionData_items;
                return /*#__PURE__*/ _jsxs("div", {
                    className: "question-topic-section",
                    children: [
                        /*#__PURE__*/ _jsx("h2", {
                            className: "section-title",
                            children: sectionData === null || sectionData === void 0 ? void 0 : (_sectionData_primary = sectionData.primary) === null || _sectionData_primary === void 0 ? void 0 : (_sectionData_primary_section_title = _sectionData_primary.section_title) === null || _sectionData_primary_section_title === void 0 ? void 0 : (_sectionData_primary_section_title_ = _sectionData_primary_section_title[0]) === null || _sectionData_primary_section_title_ === void 0 ? void 0 : _sectionData_primary_section_title_.text
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            children: sectionData === null || sectionData === void 0 ? void 0 : (_sectionData_items = sectionData.items) === null || _sectionData_items === void 0 ? void 0 : _sectionData_items.map(function(questionData, index) {
                                return _this.renderQuestion(questionData, index);
                            })
                        })
                    ]
                }, sectionData === null || sectionData === void 0 ? void 0 : sectionData.id);
            }
        },
        {
            key: "renderPrismic",
            value: function renderPrismic() {
                var _this = this;
                var _faqData_title_, _faqData_title, _faqData_body;
                var faqData = this.state.faqData;
                return !faqData ? /*#__PURE__*/ _jsx(Spinner, {}) : /*#__PURE__*/ _jsx("div", {
                    className: "message-wrapper",
                    children: /*#__PURE__*/ _jsxs("section", {
                        children: [
                            /*#__PURE__*/ _jsx("h2", {
                                className: "modal-title",
                                children: faqData === null || faqData === void 0 ? void 0 : (_faqData_title = faqData.title) === null || _faqData_title === void 0 ? void 0 : (_faqData_title_ = _faqData_title[0]) === null || _faqData_title_ === void 0 ? void 0 : _faqData_title_.text
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                children: faqData === null || faqData === void 0 ? void 0 : (_faqData_body = faqData.body) === null || _faqData_body === void 0 ? void 0 : _faqData_body.map(function(sectionData) {
                                    return _this.renderQuestionSection(sectionData);
                                })
                            })
                        ]
                    })
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var screenType = this.props.screenType;
                var content = PrismicClient.hasPrismic() ? this.renderPrismic() : this.renderHardcoded();
                return /*#__PURE__*/ _jsxs("div", {
                    className: "modal faq",
                    tabIndex: "0",
                    ref: function(node) {
                        return _this.wrapperRef = node;
                    },
                    onKeyDown: this.handleKeydown,
                    onClick: this.handleClick,
                    children: [
                        /*#__PURE__*/ _jsx("span", {
                            onClick: this.props.closeModal,
                            className: "icon icon-clear pointer"
                        }),
                        screenType.web ? /*#__PURE__*/ _jsx(CustomScrollbar, {
                            className: "faq-scrollbar",
                            style: {
                                width: SCROLLBAR.FAQ.width,
                                height: SCROLLBAR.FAQ.height
                            },
                            thumbSize: SCROLLBAR.FAQ.thumbSize,
                            children: content
                        }) : content
                    ]
                });
            }
        }
    ]);
    return FrequentlyAskedQuestions;
}(Component);
var mapStateToProps = function(param) {
    var screenType = param.screenType, i18n = param.i18n;
    return {
        screenType: screenType,
        i18n: i18n
    };
};
export default withSnackbar(connect(mapStateToProps, {
    closeModal: closeModal
})(FrequentlyAskedQuestions));
